import styled from "styled-components"

export const ImageWrap = styled.div`
    max-width: 150px;
    max-height: 150px;
    margin: 10px auto;
`